// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "city": {
      "column": {
        "default": null,
        "name": "city",
        "null": true,
        "type": "string"
      },
      "name": "city",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "ean_number": {
      "column": {
        "default": null,
        "name": "ean_number",
        "null": true,
        "type": "string"
      },
      "name": "ean_number",
      "selected_by_default": null,
      "translated": null
    },
    "email": {
      "column": {
        "default": null,
        "name": "email",
        "null": true,
        "type": "string"
      },
      "name": "email",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "string"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "note": {
      "column": {
        "default": null,
        "name": "note",
        "null": true,
        "type": "text"
      },
      "name": "note",
      "selected_by_default": null,
      "translated": null
    },
    "street_name": {
      "column": {
        "default": null,
        "name": "street_name",
        "null": true,
        "type": "string"
      },
      "name": "street_name",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "vat_number": {
      "column": {
        "default": null,
        "name": "vat_number",
        "null": true,
        "type": "string"
      },
      "name": "vat_number",
      "selected_by_default": null,
      "translated": null
    },
    "zip_code": {
      "column": {
        "default": null,
        "name": "zip_code",
        "null": true,
        "type": "string"
      },
      "name": "zip_code",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "InvoiceInfo",
  "collectionKey": "invoice_infos",
  "collectionName": "invoice_infos",
  "i18nKey": "invoice_info",
  "camelizedLower": "invoiceInfo",
  "name": "InvoiceInfo",
  "nameDasherized": "invoice-info",
  "pluralName": "invoice_infos",
  "ransackable_associations": [
    {
      "className": "InvoiceInfo::Audit",
      "collectionName": "invoice_info_audits",
      "foreignKey": "invoice_info_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "InvoiceInfoAudit",
      "through": null
    },
    {
      "className": "InvoiceInfo::Audit",
      "collectionName": "invoice_info_audits",
      "foreignKey": "invoice_info_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "InvoiceInfoAudit",
      "through": null
    },
    {
      "className": "Resource",
      "collectionName": null,
      "foreignKey": "resource_id",
      "name": "resource",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "city",
      "column": {
        "default": null,
        "name": "city",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "ean_number",
      "column": {
        "default": null,
        "name": "ean_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "email",
      "column": {
        "default": null,
        "name": "email",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "note",
      "column": {
        "default": null,
        "name": "note",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "resource_id",
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "resource_type",
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "street_name",
      "column": {
        "default": null,
        "name": "street_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "vat_number",
      "column": {
        "default": null,
        "name": "vat_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "zip_code",
      "column": {
        "default": null,
        "name": "zip_code",
        "null": true,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [],
  "paramKey": "invoice_info",
  "primaryKey": "id"
}

/** Frontend model for InvoiceInfo. */
export default class InvoiceInfo extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  city() {
    return this.readAttributeUnderscore("city")
  }

  /** @returns {boolean} */
  hasCity() {
    const value = this.city()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  eanNumber() {
    return this.readAttributeUnderscore("ean_number")
  }

  /** @returns {boolean} */
  hasEanNumber() {
    const value = this.eanNumber()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  email() {
    return this.readAttributeUnderscore("email")
  }

  /** @returns {boolean} */
  hasEmail() {
    const value = this.email()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  note() {
    return this.readAttributeUnderscore("note")
  }

  /** @returns {boolean} */
  hasNote() {
    const value = this.note()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  streetName() {
    return this.readAttributeUnderscore("street_name")
  }

  /** @returns {boolean} */
  hasStreetName() {
    const value = this.streetName()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  vatNumber() {
    return this.readAttributeUnderscore("vat_number")
  }

  /** @returns {boolean} */
  hasVatNumber() {
    const value = this.vatNumber()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  zipCode() {
    return this.readAttributeUnderscore("zip_code")
  }

  /** @returns {boolean} */
  hasZipCode() {
    const value = this.zipCode()

    return this._isPresent(value)
  }
}
